import { PROFILE_ERROR, 
  PROFILE_SUCCESS, 
  EDIT_PROFILE, 
  RESET_PROFILE_FLAG ,
  GET_PROFILE_DETAIL,
  GET_PROFILE_DETAIL_SUCCESS,
  GET_COUNTRIES,
  GET_COUNTRIES_SUCCESS,
  GET_COUNTRIES_FAILED,
  GET_STATE,
  GET_STATE_SUCCESS,
  GET_STATE_FAILED,
  VALIDATE_URL,
  VALIDATE_URL_SUCCESS,
  VALIDATE_URL_FAILED,
  EDIT_PROFILE_SUCCESS,
  EDIT_PROFILE_FAILED,
  GET_STATE2,
  ACCOUNT_SWITCH,
  ACCOUNT_SWITCH_SUCCESS,
  ACCOUNT_SWITCH_FAILED,
  ACCOUNT_SWITCH_CLEAR
} from "./actionTypes"

export const editProfile = user => {
  return {
    type: EDIT_PROFILE,
    payload: { user },
  }
}

export const editProfileSuccess=(message)=>{
  return{
    type:EDIT_PROFILE_SUCCESS,
    payload:message
  }
}

export const editProfileFailed=(error)=>{
  return{
    type:EDIT_PROFILE_FAILED,
    payload:error
  }
}

export const profileSuccess = msg => {
  return {
    type: PROFILE_SUCCESS,
    payload: msg,
  }
}

export const profileError = error => {
  return {
    type: PROFILE_ERROR,
    payload: error,
  }
}

export const resetProfileFlag = error => {
  return {
    type: RESET_PROFILE_FLAG,
  }
}

export const getProfileDetail = user => {
  return {
    type: GET_PROFILE_DETAIL,
    payload: { user },
  }
}
  
export const getProfileDataSucess = user => {
  return {
    type: GET_PROFILE_DETAIL_SUCCESS,
    payload: { user },
  }

}
export const getCountries = user => {
  return {
    type: GET_COUNTRIES,
    payload: { user },
  }

}
export const setCountriesFailed = user => {
  return {
    type: GET_COUNTRIES_FAILED,
    payload: { user },
  }

}
export const setCountriesSuccess = user => {
  return {
    type: GET_COUNTRIES_SUCCESS,
    payload: { user },
  }

}
export const getState = user => {
  return {
    type: GET_STATE,
    payload: { user },
  }

}
export const getState2 = user => {
  return {
    type: GET_STATE2,
    payload: { user },
  }

}
export const setStateFailed = user => {
  return {
    type: GET_STATE_FAILED,
    payload: { user },
  }

}
export const setStateSuccess = user => {
  return {
    type: GET_STATE_SUCCESS,
    payload: { user },
  }

}

export const validateUrl=(url)=>{
  return{
    type:VALIDATE_URL,
    payload:url
  }
}

export const validateUrlSuccess=(data)=>{
  return{
    type:VALIDATE_URL_SUCCESS,
    payload:data
  }
}

export const validateUrlFailed=(error)=>{
  return{
    type:VALIDATE_URL_FAILED,
    payload:error
  }
}

export const accountSwitch=(data)=>{
  return{
    type:ACCOUNT_SWITCH,
    payload:data
  }
}

export const accountSwitchSuccess=(data)=>{
  return{
    type:ACCOUNT_SWITCH_SUCCESS,
    payload:data
  }
}

export const accountSwitchFailed=(error)=>{
  return{
    type:ACCOUNT_SWITCH_FAILED,
    payload:error
  }
}

export const accountSwitchClear=()=>{
  return{
    type:ACCOUNT_SWITCH_CLEAR
  }
}



